export default "__VITE_ASSET__DD917J08__"